import request from '../utils/request';
import GlobalParameters from '../utils/globalParameters';

export async function loginAuth(values) {
    return request(`${GlobalParameters.website}/erams/api/cportal/auth`, {method: 'POST', data:values},null,0);
}